import styled from 'styled-components'
import { type KeyboardEvent } from 'react'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { isKeyCode } from '@/features/shared/utils/keyEvents'
import { Body } from '@shipt/design-system-typography'
import { fadeIn2 } from '@/features/shared/styles/effects'

export const MORE_CATEGORY_ITEM_ID = 'MoreCategory-category'

type Props = {
  name: string
  image: string
  drawerIsVisible: boolean
  onCategorySelect: () => void
}

export const MoreCategoryItem = ({
  name = '',
  image = '',
  drawerIsVisible = false,
  onCategorySelect,
}: Props) => {
  const handleKeyDown = (e: KeyboardEvent) => {
    if (isKeyCode(e, 'Enter')) {
      onCategorySelect()
    }
  }

  return (
    <MoreCategoryItemWrapper
      id={MORE_CATEGORY_ITEM_ID}
      role="menuitem"
      tabIndex={drawerIsVisible ? 0 : -1}
      onClick={onCategorySelect}
      onKeyDown={handleKeyDown}
    >
      <CategoryImage src={image} fallbackType="category" alt="" height={40} width={40} />
      <CategoryName>{name}</CategoryName>
    </MoreCategoryItemWrapper>
  )
}

const MoreCategoryItemWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 0.5rem 0;
  gap: 0.75rem;
  margin-right: 2rem;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.gray600};
  width: 14.375rem;
`

const CategoryName = styled(Body)`
  &:hover,
  &:focus {
    color: ${({ theme }) => theme.color.content.action.primary};
  }
`

const CategoryImage = styled(Image)`
  margin-left: 1rem;
  margin-right: 1rem;
  min-height: 2.5rem;
  min-width: 2.5rem;
  animation: ${fadeIn2};
`
